module.exports = __webpack_public_path__ + "fonts/droid-sans-mono.3f29545.woff";